import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { CircularProgress, IconButton, styled } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { useDeleteLesson } from 'hooks/useDeleteLesson';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent'
    }
}));

export const LessonContextMenu = (props: { lessonId: string, lessonName: string, onLessonDelete: (lessonId: string) => void; }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [confirmAction, setConfirmAction] = React.useState<() => void>(() => {});
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { deleteLesson, deleteLessonPending } = useDeleteLesson();

    const handleClickOpen = (message: string, action: () => void) => {
        setDialogMessage(message);
        setConfirmAction(() => action);
        setDialogOpen(true);
    };

    const handleDeleteLesson = async (onClose: () => void) => {
        onClose();
        const resp = await deleteLesson(props.lessonId);
        if (resp?.success) {
            props.onLessonDelete(props.lessonId);
        }
    }

    const onClose = (popupState: any) => {
        popupState.close();
    }

    return (
        <PopupState variant="popover" popupId="lesson-context-popup-menu">
        {(popupState) => (
            <React.Fragment>
            {deleteLessonPending
            ? <CircularProgress />
            :<IconButton {...bindTrigger(popupState)}>
                <MoreVertIcon />
            </IconButton>}
            <Menu {...bindMenu(popupState)}>
                <StyledMenuItem onClick={() => navigate(`${RoutePaths.EDITOR}/${props.lessonId}`)}>{t('lessonDataTable.editLesson')}</StyledMenuItem>
                <StyledMenuItem onClick={() => navigate(`${RoutePaths.STATISTICS}/lessons/${props.lessonId}`)}>{t('lessonDataTable.seeStatistics')}</StyledMenuItem>
                <StyledMenuItem onClick={() => navigate(`${RoutePaths.LIVE}/${props.lessonId}`)}>{t('lessonDataTable.live')}</StyledMenuItem>
                <StyledMenuItem onClick={() => handleClickOpen(t('lessonDataTable.confirmDeleteLesson', {
                    lessonName: props.lessonName
                }), () => handleDeleteLesson(() => {onClose(popupState)})) }>{t('lessonDataTable.deleteLesson')}</StyledMenuItem>
            </Menu>
            <ConfirmationDialog open={dialogOpen} handleClose={() => setDialogOpen(false)} handleConfirm={confirmAction} message={dialogMessage}/>
            </React.Fragment>
        )}
        </PopupState>
    );
}